import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/stores/authStore'
import { Box, Breadcrumbs, Typography } from '@mui/material'
import { Home as HomeIcon } from '@mui/icons-material'
import { PageHelpPopover } from '@/components/common/PageHelpPopover'
import '@/styles/dashboard.css'

export function DashboardPage() {
  const { t } = useTranslation()
  const user = useAuthStore((state) => state.user)

  const getUserDisplayName = () => {
    if (user?.name) return user.name
    if (user?.first_name) {
      const parts = [user.first_name, user.surname].filter(Boolean)
      if (parts.length > 0) return parts.join(' ')
    }
    if (user?.email) return user.email
    return t('dashboard.user')
  }

  return (
    <DashboardLayout>
      <Box sx={{ p: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            {t('dashboard.home')}
          </Typography>
        </Breadcrumbs>
        <div className="dashboard-content">
          <div className="dashboard-header-section">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              <h1 className="dashboard-title" style={{ margin: 0 }}>{t('dashboard.welcome')}</h1>
              <PageHelpPopover pageKey="dashboard" />
            </Box>
            <p className="dashboard-subtitle">
              {t('dashboard.welcomeMessage', { name: getUserDisplayName() })}
            </p>
          </div>

          <div className="dashboard-stats">
          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-book"></i>
            </div>
            <div className="stat-content">
              <h3 className="stat-value">0</h3>
              <p className="stat-label">{t('dashboard.dictionaries')}</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-font"></i>
            </div>
            <div className="stat-content">
              <h3 className="stat-value">0</h3>
              <p className="stat-label">{t('dashboard.words')}</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-tags"></i>
            </div>
            <div className="stat-content">
              <h3 className="stat-value">0</h3>
              <p className="stat-label">{t('dashboard.tags')}</p>
            </div>
          </div>
        </div>

          <div className="dashboard-sections">
            <div className="dashboard-section">
              <h2 className="section-title">{t('dashboard.recentActivity')}</h2>
              <div className="section-content">
                <p className="empty-state">{t('dashboard.noActivity')}</p>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </DashboardLayout>
  )
}
